import { defineMessages, type MessageDescriptor } from 'react-intl';

type ConfirmationMessages = {
	reminderTitle: MessageDescriptor;
	reminderDescription: MessageDescriptor;
	notInterestedTitle: MessageDescriptor;
	notInterestedDescription: MessageDescriptor;
	notInterestedUndo: MessageDescriptor;
};

export const messages: ConfirmationMessages = defineMessages({
	reminderTitle: {
		id: 'post-office.twc-loom-meeting-nudge-sidenav.reminder-confirmation.title',
		defaultMessage: 'We’ll remind you again later',
		description: 'Title confirming that the Loom calendar connection reminder was deferred',
	},
	reminderDescription: {
		id: 'post-office.twc-loom-meeting-nudge-sidenav.reminder-confirmation.description',
		defaultMessage: 'After you finish your doc, we’ll remind you to connect your calendar to Loom.',
		description: 'Description explaining when the deferred Loom reminder will return',
	},
	notInterestedTitle: {
		id: 'post-office.twc-loom-meeting-nudge-sidenav.not-interested-confirmation.title',
		defaultMessage: 'Meeting recording suggestions turned off',
		description: 'Title confirming that Loom meeting recording suggestions were turned off',
	},
	notInterestedDescription: {
		id: 'post-office.twc-loom-meeting-nudge-sidenav.not-interested-confirmation.description',
		defaultMessage: 'You won’t see meeting recording suggestions anymore.',
		description:
			'Description confirming that Loom meeting recording suggestions will no longer appear',
	},
	notInterestedUndo: {
		id: 'post-office.twc-loom-meeting-nudge-sidenav.not-interested-confirmation.undo',
		defaultMessage: 'Undo',
		description: 'Action to keep showing Loom meeting recording suggestions',
	},
});
